var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UNDEFINED_CONTRACT_ADDRESS_IN_CONSTANT } from "../common/errors";
import { DEFAULT_MULTICALL_BATCH_SIZE } from "../constants/transactions";
import { BATCH_BLOCK_SIZE, getCoreContract, getCoreContractInterface, getCoreContractMulticall, getPairContract, getPairContractInterface, getPairContractMulticall, getTokenContract, getTokenContractMulticall } from "../contracts";
import { calcBlockHeight } from "./general";
export function ETHBalance(sdk, relativeTimeInSec = 0) {
    return __awaiter(this, void 0, void 0, function* () {
        const blockTag = yield calcBlockHeight(relativeTimeInSec, sdk.context.provider);
        return yield sdk.context.signer.getBalance(blockTag);
    });
}
export function IziSwapCoreReadContracts(sdk, addresses, funcNames, args = [[]], override) {
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        for (const address of addresses) {
            for (const funcName of funcNames) {
                for (const arg of args) {
                    const func = getCoreContractMulticall(address)[funcName];
                    calls.push(func(...arg));
                }
            }
        }
        return yield sdk.context.multicallProvider.tryAll(calls, override);
    });
}
export function IziSwapCoreWriteContract(sdk, token, funcName, arg = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = getCoreContract(token, sdk.context.provider);
        return yield sdk.transactions.createContractTxn(contract, funcName, arg);
    });
}
export function ERC20ReadContracts(sdk, addresses, funcNames, args = [[]], override) {
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        for (const address of addresses) {
            for (const funcName of funcNames) {
                for (const arg of args) {
                    const func = getTokenContractMulticall(address)[funcName];
                    calls.push(func(...arg));
                }
            }
        }
        return yield sdk.context.multicallProvider.tryAll(calls, override);
    });
}
export function ERC20WriteContract(sdk, token, funcName, arg = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = getTokenContract(token, sdk.context.provider);
        return yield sdk.transactions.createContractTxn(contract, funcName, arg);
    });
}
export function ExchangeReadContracts(sdk, funcNames, args = [[]], override) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        for (const funcName of funcNames) {
            for (const arg of args) {
                const func = (_b = (_a = sdk.context.multicallContracts) === null || _a === void 0 ? void 0 : _a.Exchange) === null || _b === void 0 ? void 0 : _b[funcName];
                calls.push(func(...arg));
            }
        }
        return yield sdk.context.multicallProvider.tryAll(calls, override);
    });
}
export function ExchangeWriteContract(sdk, funcName, arg = []) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const contract = (_a = sdk.context.contracts) === null || _a === void 0 ? void 0 : _a.Exchange;
        if (!contract) {
            throw new Error(UNDEFINED_CONTRACT_ADDRESS_IN_CONSTANT);
        }
        return yield sdk.transactions.createContractTxn(contract, funcName, arg);
    });
}
export function PairReadContracts(sdk, addresses, funcNames, args = [[]], override) {
    return __awaiter(this, void 0, void 0, function* () {
        const totalCalls = addresses.length * funcNames.length * args.length;
        let ret = [];
        const batchCnt = Math.floor(totalCalls / DEFAULT_MULTICALL_BATCH_SIZE) + 1;
        for (let batchIndex = 0; batchIndex < batchCnt; batchIndex++) {
            const calls = [];
            let cnt = 0;
            for (const address of addresses) {
                for (const funcName of funcNames) {
                    for (const arg of args) {
                        if (cnt < batchIndex * DEFAULT_MULTICALL_BATCH_SIZE ||
                            cnt >= (batchIndex + 1) * DEFAULT_MULTICALL_BATCH_SIZE) {
                            cnt++;
                            continue;
                        }
                        cnt++;
                        const func = getPairContractMulticall(address)[funcName];
                        calls.push(func(...arg));
                    }
                }
            }
            const res = yield sdk.context.multicallProvider.tryAll(calls, override);
            ret = ret.concat(res);
        }
        return ret;
    });
}
export function PairWriteContract(sdk, market, funcName, arg = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = getPairContract(market, sdk.context.provider);
        return yield sdk.transactions.createContractTxn(contract, funcName, arg);
    });
}
export function PairContractCallStatic(sdk, market, funcName, arg = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = getPairContract(market, sdk.context.provider);
        //@ts-ignore
        return yield contract.connect(sdk.context.signer).callStatic[funcName](...arg);
    });
}
export function BankReadContracts(sdk, funcNames, args = [[]], override) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        for (const funcName of funcNames) {
            for (const arg of args) {
                const func = (_b = (_a = sdk.context.multicallContracts) === null || _a === void 0 ? void 0 : _a.BitlyBank) === null || _b === void 0 ? void 0 : _b[funcName];
                calls.push(func(...arg));
            }
        }
        return yield sdk.context.multicallProvider.tryAll(calls, override);
    });
}
export function BankWriteContract(sdk, funcName, arg = [], txnOptions = {}) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const contract = (_a = sdk.context.contracts) === null || _a === void 0 ? void 0 : _a.BitlyBank;
        if (!contract) {
            throw new Error(UNDEFINED_CONTRACT_ADDRESS_IN_CONSTANT);
        }
        return yield sdk.transactions.createContractTxn(contract, funcName, arg, txnOptions);
    });
}
export function BTLYReadContracts(sdk, funcNames, args = [[]], override) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const calls = [];
        for (const funcName of funcNames) {
            for (const arg of args) {
                const func = (_b = (_a = sdk.context.multicallContracts) === null || _a === void 0 ? void 0 : _a.BTLYToken) === null || _b === void 0 ? void 0 : _b[funcName];
                calls.push(func(...arg));
            }
        }
        return yield sdk.context.multicallProvider.tryAll(calls, override);
    });
}
export function BTLYWriteContract(sdk, funcName, arg = []) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const contract = (_a = sdk.context.contracts) === null || _a === void 0 ? void 0 : _a.BTLYToken;
        if (!contract) {
            throw new Error(UNDEFINED_CONTRACT_ADDRESS_IN_CONSTANT);
        }
        return yield sdk.transactions.createContractTxn(contract, funcName, arg);
    });
}
export function getIziSwapCoreLog(sdk, coreAddress, fromBlock, toBlock, event, args = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const filters = getCoreContract(coreAddress, sdk.context.provider).filters[event](...args);
        let currentFrom = Number(fromBlock);
        const targetTo = Number(toBlock);
        const networkId = sdk.context.networkId;
        const promises = [];
        while (currentFrom <= targetTo) {
            const currentTo = Math.min(currentFrom + BATCH_BLOCK_SIZE[networkId.toString()], targetTo);
            promises.push(sdk.context.provider.getLogs(Object.assign(Object.assign({}, filters), { fromBlock: currentFrom, toBlock: currentTo })));
            currentFrom = currentTo + 1;
        }
        const batchResults = yield Promise.all(promises);
        // Flatten the results from all promises
        let logs = [];
        for (const batchResult of batchResults) {
            logs = logs.concat(batchResult);
        }
        const iface = getCoreContractInterface();
        const parsedLogs = logs.map(log => {
            return Object.assign(Object.assign({}, iface.parseLog(log)), log);
        });
        return parsedLogs;
    });
}
export function getMarketLog(sdk, market, fromBlock, toBlock, event, args = []) {
    return __awaiter(this, void 0, void 0, function* () {
        const filters = getPairContract(market, sdk.context.provider).filters[event](...args);
        let currentFrom = Number(fromBlock);
        const targetTo = Number(toBlock);
        const networkId = sdk.context.networkId;
        const promises = [];
        while (currentFrom <= targetTo) {
            const currentTo = Math.min(currentFrom + BATCH_BLOCK_SIZE[networkId.toString()], targetTo);
            promises.push(sdk.context.provider.getLogs(Object.assign(Object.assign({}, filters), { fromBlock: currentFrom, toBlock: currentTo })));
            currentFrom = currentTo + 1;
        }
        const batchResults = yield Promise.all(promises);
        // Flatten the results from all promises
        let logs = [];
        for (const batchResult of batchResults) {
            logs = logs.concat(batchResult);
        }
        const iface = getPairContractInterface();
        const parsedLogs = logs.map(log => {
            return Object.assign(Object.assign({}, iface.parseLog(log)), log);
        });
        return parsedLogs;
    });
}
export function internalFetchMarketsAndTokens(sdk, marketName = "") {
    return __awaiter(this, void 0, void 0, function* () {
        const pairs = yield ExchangeReadContracts(sdk, ['pairs'], [[marketName]]);
        if (!pairs) {
            return { markets: [], tokens: [] };
        }
        const tokensSet = new Set();
        for (const pair of pairs[0]) {
            tokensSet.add(pair.tokenX);
            tokensSet.add(pair.tokenY);
        }
        const pairInfos = yield PairReadContracts(sdk, pairs[0].map(e => e.pair), ['pairInfo']);
        const tokenInfos = yield ExchangeReadContracts(sdk, ['tokenInfo'], Array.from(tokensSet).map(e => ([e])));
        const tokens = [];
        const tokensObj = {};
        const tokensList = Array.from(tokensSet);
        for (let i = 0; i < tokenInfos.length; i++) {
            const info = tokenInfos[i];
            const address = tokensList[i];
            tokensObj[address] = info;
            tokens.push(Object.assign(Object.assign({}, info), { address }));
        }
        const markets = [];
        for (let i = 0; i < pairs[0].length; i++) {
            const pair = pairs[0][i];
            const tokenXInfo = Object.assign(Object.assign({}, tokensObj[pair.tokenX]), { address: pair.tokenX });
            const tokenYInfo = Object.assign(Object.assign({}, tokensObj[pair.tokenY]), { address: pair.tokenY });
            markets.push({
                marketAddress: pair.pair,
                displayName: `${tokenXInfo.symbol}/${tokenYInfo.symbol}`,
                detail: pairInfos[i],
                tokenX: tokenXInfo,
                tokenY: tokenYInfo,
            });
        }
        return { markets, tokens };
    });
}
